export default "__VITE_ASSET__Erdsw3o4__"